import { render, staticRenderFns } from "./project-acceptance.vue?vue&type=template&id=4086e335&scoped=true"
import script from "./project-acceptance.vue?vue&type=script&lang=js"
export * from "./project-acceptance.vue?vue&type=script&lang=js"
import style0 from "./project-acceptance.vue?vue&type=style&index=0&id=4086e335&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4086e335",
  null
  
)

export default component.exports